import { TType } from "types/shared"
import { IContent } from "types/content";

import { Text, Flex, Box } from "@chakra-ui/react";
import Input from "components/UI/atoms/Input";

export const getColumns = (T: TType, contentTypeInputValues: any, handleContentTypeInputChange: any) => {
  const columns = [
    {
      key: "language_settings.table.columns.entityType",
      // T("language_settings.table.columns.entity_type_label")
      label: T("Entity Type"),
      render: (data: IContent) => <Text>{data.entityType}</Text>
    },
    {
      key: "language_settings.table.columns.objectType",
      // T("language_settings.table.columns.object_type_label")
      label: T("Object Type"),
      render: (data: IContent) => <Text>{data.objectType}</Text>
    },
    {
      key: "language_settings.table.columns.key",
      // T("language_settings.table.columns.key_label")
      label: T("Key"),
      render: (data: IContent) => <Text>{data.key}</Text>
    },
    {
      key: "language_settings.table.columns.languages",
      // T("language_settings.table.columns.languages_label")
      label: T("Languages"),
      render: (data: any) => {
        const generatedKey = `${data.objectType}-${data.entityType}-${data.key}`
        const langs: any = []

        for (const lang in data.langs) {
          if (data.langs[lang]) {
            langs.push({
              key: lang,
              value: data.langs[lang]
            })
          }
        }

        return (
          <Flex alignItems="center" justifyContent="space-around">
            {langs.map((lang: any) => (
              <Box key={`${generatedKey}-${lang.key}`}>
                <Input
                  id={generatedKey}
                  styles={{
                    width: "100%",
                    height: "50px",
                  }}
                  name={generatedKey}
                  value={contentTypeInputValues ? contentTypeInputValues[generatedKey][lang.key] || "" : ""}
                  onChange={(e: any) => handleContentTypeInputChange(e, lang.key)}
                  type="text"
                  label={lang.key}
                />
              </Box>
            ))}
          </Flex>
        )
      }
    }
  ]

  return columns
}